import Vue from "vue";
import format from "date-fns/format";
import toDate from "date-fns/toDate";

Vue.filter('moment', function (v, f) {
    if (!v) return '';
    let date = toDate(v)
    return format(date,f);
});